import { colliding } from './colliding'

/**
 * @param {import('@pogzul/engine').Shape} shape
 * @this {import('@pogzul/engine').Runtime}
 */
export function contain(shape) {
  colliding.call(this, shape, this.window, ({ resolve }) => resolve())
}
